import { 
    FaRegEdit, 
    FaRegClone, 
    FaChevronDown, 
    FaBars 
} from 'react-icons/fa'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { useCouponAndModalForms } from '../couponAndModalFormsContext'

import { Container, ContentCoupom, Text, BallLeft, Content } from './style'


export function Coupon({ couponDatas }) {
    const { setCouponDatasToCreateOrEdit, setTotalCoupons } = useCouponAndModalForms()

    const dispatch = useDispatch()
    
    const linkToShare = `${process.env.REACT_APP_URL}menu/${couponDatas.apiName}/coupon/${couponDatas.description}`

    function handleClickToEdit() {
        dispatch({type: 'OPEN_MODALFORMS_EDIT', title: 'Editando Cupom'})
        setCouponDatasToCreateOrEdit(couponDatas)
        setTotalCoupons(couponDatas.availableQuantity)
    }

    function handleClickToShare() {
        navigator.clipboard.writeText(linkToShare).then(function() {
            toast.success("✔️ Link copiado com sucesso!")
          }, function() {
           toast.error("Algo deu errado, tente novamente")
          })
    }

    function handleOpenCouponDetails() {
        dispatch({
            type: 'OPEN_CENTRALIZEDMODAL', 
            title: "Detalhes do cupom", 
            componentToShow: 'couponDetailedInformations',
            datasComponent: { 
               idCoupon: couponDatas.idCoupon
            } 
        })
    }
    

    return(
        <Container>

         <Content>

            <BallLeft />

                <ContentCoupom>
                    {
                        <div className="remaining">
                            <FaChevronDown /> Ver detalhes
                            
                            <div>
                                <p>
                                    <strong>Total: </strong> 
                                    {
                                        couponDatas.unlimited 
                                        ? `Ilimitado`
                                        : couponDatas.availableQuantity
                                    }
                                </p>
                                <p>
                                    <strong>Usados: </strong> 
                                    {couponDatas.unavailableQuantity}
                                </p>
                                <p>
                                    <strong>Restante: </strong> 
                                    {
                                        couponDatas.unlimited 
                                        ? `Ilimitado`
                                        : couponDatas.remainingQuantity
                                    }
                                </p>
                            </div>
                        </div>
                    }

                    <Text>
                        <strong>
                            {couponDatas.description}
                        </strong>
                    </Text>



                </ContentCoupom>

                <div className="buttonSelect">
                    <div onClick={handleClickToShare}>
                        <FaRegClone />
                        <p>Copiar Link</p>
                    </div>

                    <div onClick={handleOpenCouponDetails}>
                        <FaBars />
                        <p>Detalhes</p>
                    </div>

                    {
                        !couponDatas.isFranquia &&
                        <div onClick={handleClickToEdit}>
                            <FaRegEdit />
                            <p>Editar</p>
                        </div>
                    }
                </div>

            </Content>

        </Container>
    )
}